import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amountUSD: number;
  className?: string;
}
export function PriceDisplay({
  amountUSD,
  className = ''
}: PriceDisplayProps) {
  const [formattedPrice, setFormattedPrice] = useState(`$${amountUSD.toString().replace('.', ',')} USD`);
  useEffect(() => {
    try {
      const locale = navigator.language || 'es-ES';
      let currency = 'USD';
      let symbol = '$';
      if (locale.startsWith('en-GB')) {
        currency = 'GBP';
        symbol = '£';
      } else if (locale.includes('EU') || ['de', 'fr', 'es-ES', 'it', 'pt-PT'].some(l => locale.startsWith(l))) {
        currency = 'EUR';
        symbol = '€';
      }
      let convertedAmount = amountUSD;
      if (currency === 'EUR') convertedAmount = amountUSD * 0.92;
      if (currency === 'GBP') convertedAmount = amountUSD * 0.79;
      const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: amountUSD % 1 === 0 ? 0 : 2
      });
      setFormattedPrice(`${formatter.format(convertedAmount)} ${currency}`);
    } catch (e) {
      setFormattedPrice(`$${amountUSD.toString().replace('.', ',')} USD`);
    }
  }, [amountUSD]);
  return <span className={className} data-id="element-225">{formattedPrice}</span>;
}